module.exports = __webpack_public_path__ + "static/media/sad.2c930771.svg";